module.exports = __webpack_public_path__ + "static/img/b11.bd2a733.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b11.png
// module id = EPfa
// module chunks = 1